<template>
    <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        background-color="#231544"
        text-color="#fff"
        router
        active-text-color="#fff"
    >
<!--        <el-menu-item>亿万未来</el-menu-item>-->
<!--        <el-menu-item index="myqb" style="float: right">蜜柚钱包</el-menu-item>-->
<!--        <el-menu-item index="qxb" style="float: right">钱小宝</el-menu-item>-->
        <!-- <el-menu-item index="hyq" style="float: right">惠有钱</el-menu-item> -->
<!--        <el-menu-item index="wyh" style="float: right">无忧花</el-menu-item>-->
<!--        <el-menu-item index="home" style="float: right">小花薪</el-menu-item>-->
    </el-menu>
</template>

<script>
export default {
    data() {
        return {
            activeIndex: "home",
        };
    },
    mounted() {
        switch (this.$route.path) {
            case "/xjk":
                this.activeIndex = "xjk";
                break;
            case "/hyq":
                this.activeIndex = "hyq";
                break;
            case "/qxb":
                this.activeIndex = "qxb";
                break;
            case "/myqb":
                this.activeIndex = "myqb";
                break;
            default:
                this.activeIndex = "home";
                break;
        }
    },
};
</script>
